var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isIpadHeng)?_c('router-view',{key:new Date()+'1'}):_c('div',{staticClass:"ipadHp"},[_c('div',[_c('img',{attrs:{"src":require("./assets/hp.png"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("请切换竖屏浏览！")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b4a99ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 